import { initializeApp } from 'firebase/app';
import { UploadTaskSnapshot, getDownloadURL, getStorage } from 'firebase/storage';
import { ref, uploadBytesResumable } from 'firebase/storage';
import { v4 } from 'uuid';

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const uploadImageAndGetUrl = async (file: Blob | any) => {
  console.log('Came here!');
  const storage = getStorage(app);
  const dateString = new Date().toJSON().slice(0, 10);
  const fileRef = ref(
    storage,
    `${process.env.IMAGE_STORAGE_PATH}/${dateString}/${v4()}-${file.name}`,
  );

  // Initiate the upload
  const uploadTask = uploadBytesResumable(fileRef, file);

  // Attach event listeners to track upload progress and completion
  let isSuccess = false;
  let downloadLink = '';

  await new Promise((resolve, reject) => {
    uploadTask.on(
      'state_changed',
      (snapshot: UploadTaskSnapshot) => {
        // Handle progress updates (optional)
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
      },
      (error: any) => {
        // Handle unsuccessful uploads
        isSuccess = false;
        console.error('File upload error', error);
        reject(error);
      },
      async () => {
        // Handle successful uploads
        console.log('Image uploaded successfully');
        isSuccess = true;
        // Get the download URL of the uploaded image
        try {
          downloadLink = await getDownloadURL(fileRef);
          resolve(null);
        } catch (error) {
          console.error('Error getting download URL:', error);
          reject(error);
        }
      },
    );
  });

  return { isSuccess, downloadLink };
};
